import { useState } from "react";
import Input from "../common/Input";

const ConfigurationFormField = ({ field, value, onChange, error, options = [] }) => {
  const [showPassword, setShowPassword] = useState(false);

  if (field.isSelect) {
    return (
      <div className="mb-4 w-full">
        <label className="block text-sm font-medium mb-1">{field.label}</label>
        <Input
          type="select"
          className="mt-1 w-full border rounded px-3 py-2 text-sm"
          value={options.find((opt) => opt.value === value)}
          options={options}
          placeholder={field.placeholder || "Select"}
          onChange={(select) => onChange(field.name, select?.value)}
        />
        {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
      </div>
    );
  }

  return (
    <div className="mb-4 w-full relative">
      <label className="block text-sm font-medium mb-1">{field.label}</label>
      <Input
        type={
          field.isPassword ? (showPassword ? "text" : "password") : field.type
        }
        name={field.name}
        value={value || ""}
        onChange={(e) => onChange(field.name, e.target.value)}
        className="w-full border rounded-lg px-3 py-2 focus:ring focus:ring-blue-300"
        placeholder={field.placeholder || ""}
      />
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
};

export default ConfigurationFormField;
